<template>
    <div>
        <h1 class="subtitle">
            Fins de contrat détectées modifiables - {{ user.dgo }}
        </h1>
        <div class="input-form field">
            <label>EAN : </label>
            <input type="text" pattern="\d" inputmode="numeric" maxlength="100" class="input input-medium" v-model="filterEAN" @input="onFilterEANChange()">
        </div>
        <div>
            <!-- Table -->
            <div class="table-container">
                <table class="table is-hoverable">
                <thead>
                    <tr>
                        <th>GRD</th>
                        <th>EAN</th>
                        <th>Statut</th>
                        <th>Date effective</th>
                        <th>Date de détection</th>
                        <th>Module</th>
                        <th>Label</th>
                        <th>Nbr d'utilisateurs impactés</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="loadingData"><td class="has-text-centered" colspan="20">Chargement des données ...</td></tr>
                    <template v-else>
                        <tr v-if="eocList.length == 0"><td class="has-text-centered" colspan="20">Pas de fins de contrats modifiables</td></tr>
                        <tr v-else v-for="eoc in eocList" v-bind:key="eoc.id">
                            <td>{{ eoc.dgo }}</td>
                            <td>{{ eoc.EAN }}</td>
                            <td><strong>{{ eoc.isCanceled ? "Annulé" : "Actif" }}</strong></td>
                            <td>{{ formatDateToText(eoc.effectiveDate) }}</td>
                            <td>{{ formatDateToText(eoc.registeredAt) }}</td>
                            <td>{{ eoc.module }}</td>
                            <td>{{ eoc.label }}</td>
                            <td>{{ eoc.clipodIDs.length }}</td>
                            <td><button @click="eocToChange=eoc; showConfirmChangeEOCStateModal=true" class="button is-small is-warning">{{ eoc.isCanceled ? "Réactiver" : "Annuler" }}</button></td>
                        </tr>
                    </template>
                </tbody>
                </table>
            </div>

            <!-- Pagination -->
            <div class="horizontal-wrapper">
                <div class="field is-grouped">
                <div class="control">
                    <button
                    :disabled="indexPage <= 0 || loadingData"
                    class="button is-small"
                    @click="indexPage--; getEOCList()">Précédent</button>
                </div>
                <div class="control"><span class="is-size-7"><strong>Page {{indexPage+1}}</strong></span></div>
                <div class="control">
                    <button
                    :disabled="lastPage || loadingData"
                    class="button is-small"
                    @click="indexPage++; getEOCList()">Suivant</button>
                    </div>
                </div>
            </div>
        </div>
        <ConfirmActionModal
            ref="confirmActionModal"
            :isActive="showConfirmChangeEOCStateModal"
            message="Changer le statut de cette fin de contrat ? Les utilisateurs impactés seront alertés du changement par mail."
            @close="showConfirmChangeEOCStateModal = false; eocToChange=null"
            @confirm="toggleEOC"
        />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { EOCService } from '../../services'
import moment from 'moment'
import ConfirmActionModal from '../../components/ConfirmActionModal.vue'

export default {
    components: {
        ConfirmActionModal
    },
    data() {
        return {
            eocList: [],
            filterEAN: "",
            indexPage: 0,
            eocToChange: null,
            showConfirmChangeEOCStateModal: false,
            loadingData: false,
            lastPage: false,
        }
    },
    computed: {
        ...mapState({ user: state => state.account.user })
    },
    methods: {
        onFilterEANChange() {
            this.indexPage = 0
            this.getEOCList()
        },
        formatDateToText(date) {
            return moment(date).format('DD-MM-YYYY')
        },
        getEOCList() {
            this.loadingData = true
            EOCService.getEOCList({ EAN: this.filterEAN, page: this.indexPage, nbElemsPerPage: 10 }).then(response => {
                this.eocList = response.eocList
                this.lastPage = response.lastPage
            })
            this.loadingData = false
        },
        toggleEOC() {
            EOCService.changeStateOfEOC({
                adminID: this.user._id,
                eocID: this.eocToChange.id,
                isCancel: !this.eocToChange.isCanceled,
                EAN: this.eocToChange.EAN
            }).then(response => {
                this.$refs.confirmActionModal.handleResult({ success: response.id && response.id != null })
                this.getEOCList()
            })
        }
    },
    created() {
        this.getEOCList()
    }
  }
</script>

<style lang="scss" scoped>
</style>